import React, {useEffect, useCallback, useState} from 'react';
import PropTypes from 'prop-types';

// Stylesheets
import "./JimmyKeyModal.css";

// Assets
import close_icon from '../../../assets/cancel-24px.svg';
import {GetCurrency, SendAction} from "../../../utility/Utils";

const JimmyKeyModal = ({
  product,
  closeModal,
  imageApiUrl,
  showMetadata,
  partner,
  videoId,
  modalButtonTitle
}) => {

  const [hover, setHover] = useState(false);

  const escFunction = useCallback((event) => {
    if(event.keyCode === 27) { // keyCode 27 is Esc char
      closeModal();
    }
  }, [closeModal]);

  useEffect(() => {
    // add listener for Esc to close modalReact
    document.addEventListener("keydown", escFunction);

    return () => {
      // upon closing modalReact, remove listener
      document.removeEventListener("keydown", escFunction);
    };
  }, [escFunction]);

  const handleModalOnClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    SendAction(partner, videoId, "click", product["id"])

    if (product["linkUrl"]) {
      window.open(product["linkUrl"]);
    }
    closeModal()
  }

  const handleVideoHover = () => {
    setHover(true);
  }

  const handleVideoUnHover = () => {
    setHover(false);
  }

  const { id, name, price, discountedPrice, longDescription, imageUrl, currency, modalTitle } = product

  const imageUrlPublic = `${imageApiUrl}/${imageUrl}`;

  const buyNowPrice = discountedPrice || price;

  const isNotFound = id === 'notFoundProduct';

  return (
    <div className="modal pos-absolute" >
    <div className="modal__overlay" onClick={closeModal}></div>
      <div className="modal__el pd-0">
        <div ><img style={{width: "auto", height: "195px",justifyContent: "center",
          textAlign: "center",
          display: "block",
          alignItems: "center",
          margin: "auto"}}  src={imageUrlPublic} alt={id} /></div>
        <div className="pd-3">
          <div className="modal-product-name mg-b-1">{name}</div>
          <div className="modal-product-description mg-b-25">{longDescription}</div>
          <div className="modal-product-actions">
            {!isNotFound && <button className="modal-product-buy-now btn btn--primary full-width" onClick={handleModalOnClick}
                    onMouseEnter={handleVideoHover}
                    onMouseLeave={handleVideoUnHover}>
              <span className="modal-product-buy-now__price mg-r-05">{`${GetCurrency(currency)}${buyNowPrice}`}</span>
              <span>{modalButtonTitle}</span>
            </button>}

            {isNotFound && <button className="modal-product-buy-now btn btn--primary full-width" onClick={handleModalOnClick}
                                    >
              <span>{modalTitle}</span>
            </button>}
          </div>
          {false && showMetadata && <div className="modal-tooltip"><span >{!hover ? "* Demo!" : " * Thanks!"}</span></div> }
        </div>
        <div className="modal-close pos-absolute"><img src={close_icon} onClick={closeModal} alt="close" /></div>
      </div>
    </div>
  )
}

JimmyKeyModal.propTypes = {
  productId: PropTypes.string,
  closeModal: PropTypes.func,
  products: PropTypes.array,
};

export default JimmyKeyModal;
